export default __webpack_public_path__ + "285d640f64ecdf9d1ec6c5cc650f8ed5.svg";